import React from 'react';
import PropTypes from 'prop-types';
import { gql } from '@common/hooks';
import { Button } from 'antd';
import { ExtendOfferDrawer } from 'works/legacy/components/extension-offer/extend-offer-drawer';

export function ExtendOffer({ assignment, buttonType, buttonText }) {
  if (!assignment.canExtend.value) return null;

  return (
    <ExtendOfferDrawer
      assignment={assignment}
      trigger={<Button type={buttonType}>{buttonText || 'Extend'}</Button>}
    />
  );
}

ExtendOffer.propTypes = {
  assignment: PropTypes.object,
  buttonType: PropTypes.string,
  buttonText: PropTypes.string,
};

ExtendOffer.defaultProps = {
  buttonType: 'primary',
};

ExtendOffer.fragment = gql`
  fragment ExtendOfferFragment on StaffingRequestAssignment {
    id
    billingRegularRate
    shiftsPerWeek
    hoursPerShift
    endDate
    finalEndDate
    shiftType
    lengthInWeeks
    employmentType
    canExtend {
      value
    }
    canApproveExtensions {
      value
    }
    supplier {
      id
      name
    }
    organization {
      id
      name
    }
    staffingRequest {
      id
      externalId
      staffingRequestType
      roleLevel

      organizationUnit {
        id
        department {
          id
          organizationBusiness {
            id
            city
            stateCode
          }
        }
      }
    }
    worksProfile {
      id
    }
  }
`;
